module.exports = __webpack_public_path__ + "static/media/8OLA29.d6368f30.jpg";